"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _mixinPanel = _interopRequireDefault(require("@/libs/flowable/common/mixinPanel"));
var _listenerParam = _interopRequireDefault(require("./listenerParam"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    listenerParam: _listenerParam.default
  },
  mixins: [_mixinPanel.default],
  data: function data() {
    return {
      dialogVisible: true,
      showParamDialog: false,
      nowIndex: null,
      formData: {
        taskListener: []
      }
    };
  },
  computed: {
    formConfig: function formConfig() {
      //   const _this = this
      return {
        inline: false,
        item: [{
          xType: 'tabs',
          tabs: [{
            label: '任务监听器',
            name: 'taskListener',
            column: [{
              label: '事件',
              name: 'event',
              width: 180,
              rules: [{
                required: true,
                message: '请选择',
                trigger: ['blur', 'change']
              }],
              xType: 'select',
              dic: [{
                label: 'create',
                value: 'create'
              }, {
                label: 'assignment',
                value: 'assignment'
              }, {
                label: 'complete',
                value: 'complete'
              }, {
                label: 'delete',
                value: 'delete'
              }],
              tooltip: "create\uFF08\u521B\u5EFA\uFF09\uFF1A\u5F53\u4EFB\u52A1\u5DF2\u7ECF\u521B\u5EFA\uFF0C\u5E76\u4E14\u6240\u6709\u4EFB\u52A1\u53C2\u6570\u90FD\u5DF2\u7ECF\u8BBE\u7F6E\u65F6\u89E6\u53D1\u3002<br />\n                              assignment\uFF08\u6307\u6D3E\uFF09\uFF1A\u5F53\u4EFB\u52A1\u5DF2\u7ECF\u6307\u6D3E\u7ED9\u67D0\u4EBA\u65F6\u89E6\u53D1\u3002\u8BF7\u6CE8\u610F\uFF1A\u5F53\u6D41\u7A0B\u6267\u884C\u5230\u8FBE\u7528\u6237\u4EFB\u52A1\u65F6\uFF0C\u5728\u89E6\u53D1create\u4E8B\u4EF6\u4E4B\u524D\uFF0C\u4F1A\u9996\u5148\u89E6\u53D1assignment\u4E8B\u4EF6\u3002<br />\n                              complete\uFF08\u5B8C\u6210\uFF09\uFF1A\u5F53\u4EFB\u52A1\u5DF2\u7ECF\u5B8C\u6210\uFF0C\u4ECE\u8FD0\u884C\u65F6\u6570\u636E\u4E2D\u5220\u9664\u524D\u89E6\u53D1\u3002<br />\n                              delete\uFF08\u5220\u9664\uFF09\uFF1A\u5728\u4EFB\u52A1\u5373\u5C06\u88AB\u5220\u9664\u524D\u89E6\u53D1\u3002\u8BF7\u6CE8\u610F\u4EFB\u52A1\u7531completeTask\u6B63\u5E38\u5B8C\u6210\u65F6\u4E5F\u4F1A\u89E6\u53D1\u3002\n                    "
            }, {
              label: '类型',
              name: 'type',
              width: 180,
              rules: [{
                required: true,
                message: '请选择',
                trigger: ['blur', 'change']
              }],
              xType: 'select',
              dic: [{
                label: '类',
                value: 'class'
              }, {
                label: '表达式',
                value: 'expression'
              }, {
                label: '委托表达式',
                value: 'delegateExpression'
              }]
            }, {
              label: 'java 类名',
              name: 'className',
              xType: 'input',
              rules: [{
                required: true,
                message: '请输入',
                trigger: ['blur', 'change']
              }]
            }, {
              xType: 'slot',
              label: '参数',
              width: 120,
              slot: true,
              name: 'params'
            }]
          }]
        }]
      };
    }
  },
  mounted: function mounted() {
    var extensionElements = this.element.businessObject.extensionElements;
    if (extensionElements !== undefined && extensionElements !== null) {
      var obj2 = extensionElements.values.filter(function (item) {
        return item.$type === 'flowable:TaskListener';
      }).map(function (item) {
        var type;
        if ('class' in item) type = 'class';
        if ('expression' in item) type = 'expression';
        if ('delegateExpression' in item) type = 'delegateExpression';
        if (item.fields !== undefined && item.fields !== null) {
          var obj = item.fields.map(function (field) {
            var fieldType;
            if ('stringValue' in field) fieldType = 'stringValue';
            if ('expression' in field) fieldType = 'expression';
            return {
              name: field.name,
              type: fieldType,
              value: field[fieldType]
            };
          });
          return {
            event: item.event,
            type: type,
            className: item[type],
            params: obj != null ? obj : []
          };
        } else {
          return {
            event: item.event,
            type: type,
            className: item[type],
            params: []
          };
        }
      });
      if (obj2 !== undefined && obj2 !== null) {
        this.formData.taskListener = obj2;
      } else {
        this.formData.taskListener = [];
      }
    }
  },
  methods: {
    configParam: function configParam(index) {
      this.nowIndex = index;
      var nowObj = this.formData.taskListener[index];
      if (!nowObj.params) {
        nowObj.params = [];
      }
      this.showParamDialog = true;
    },
    finishConfigParam: function finishConfigParam(param) {
      this.showParamDialog = false;
      // hack 数量不更新问题
      var cache = this.formData.taskListener[this.nowIndex];
      cache.params = param;
      this.$set(this.formData.taskListener[this.nowIndex], this.nowIndex, cache);
      this.nowIndex = null;
    },
    updateElement: function updateElement() {
      var _this = this;
      if (this.formData.taskListener.length) {
        var extensionElements = this.element.businessObject.get('extensionElements');
        if (!extensionElements) {
          extensionElements = this.modeler.get('moddle').create('bpmn:ExtensionElements');
        }
        if (extensionElements.values !== undefined && extensionElements.values !== null) {
          // 清除旧值
          var obj = extensionElements.values.filter(function (item) {
            return item.$type !== 'flowable:TaskListener';
          });
          if (obj !== undefined && obj !== null) {
            extensionElements.values = [];
          } else {
            extensionElements.values = obj;
          }
        }
        this.formData.taskListener.forEach(function (item) {
          var taskListener = _this.modeler.get('moddle').create('flowable:TaskListener');
          taskListener['event'] = item.event;
          taskListener[item.type] = item.className;
          if (item.params && item.params.length) {
            item.params.forEach(function (field) {
              var fieldElement = _this.modeler.get('moddle').create('flowable:Field');
              fieldElement['name'] = field.name;
              fieldElement[field.type] = field.value;
              // 注意：flowable.json 中定义的string和expression类为小写，不然会和原生的String类冲突，此处为hack
              // const valueElement = this.modeler.get('moddle').create(`flowable:${field.type}`, { body: field.value })
              // fieldElement[field.type] = valueElement
              taskListener.get('fields').push(fieldElement);
            });
          }
          extensionElements.get('values').push(taskListener);
        });
        this.updateProperties({
          extensionElements: extensionElements
        });
      } else {
        var _extensionElements = this.element.businessObject["extensionElements"];
        if (_extensionElements.values) {
          var obj2 = _extensionElements.values.filter(function (item) {
            return item.$type !== 'flowable:TaskListener';
          });
          if (obj2 !== undefined && obj2 !== null) {
            _extensionElements.values = [];
          } else {
            _extensionElements.values = obj2;
          }
        }
      }
    },
    closeDialog: function closeDialog() {
      var _this2 = this;
      this.$refs.xForm.validate().then(function () {
        _this2.updateElement();
        _this2.dialogVisible = false;
      }).catch(function (e) {
        return console.error(e);
      });
    }
  }
};